import { render, staticRenderFns } from "./ResetConversations.vue?vue&type=template&id=fb016b30&"
import script from "./ResetConversations.vue?vue&type=script&lang=js&"
export * from "./ResetConversations.vue?vue&type=script&lang=js&"
import style0 from "./ResetConversations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports